/* eslint-disable */
import runFirst from './run_first'
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import Router from 'vue-router'
import VueAWN from "vue-awesome-notifications"
import store from './store'
import router from './router'
import App from './components/public/App'

Vue.config.productionTip = false

// ----------------------------------------------- Plugins --------------------------------------
Vue.use(Vuex)
Vue.use(Router)
let options = {maxNotifications:1 ,position: 'top-right'}
Vue.use(VueAWN, options)



Vue.directive('browser-navigation', {
  unbind() {
    window.onpopstate = null;
  },
  bind() {
    window.onpopstate = () => {
      window.vue_instance.$data.backForwardUrlRequest.count++;
    };
  }
})

window.vue_instance = new Vue({
  el: '#app',
    template: '<App/>',
    components: { App },
    data: {
      
        userInfo: {
            firstName: 'DGnet Watchdog Guest',
            lastName: '',
            contactEmail: '',
            uid: 0,
            authenticated: false,

            isGuest: false
        },
        watchdog: {
            orgMetaData: {},
            orgPermissions:{},
            orgParentsLookup: {},
            orgUserPermissionsLastUpdated: {},
            orgSystemJoinsReverseLookup: {},
            presets:{},
            objectsMetaData: {},
            objectAttributesMetaData: {},
            systemObjectJoins: {},
            systemObjectJoinsReverseLookup: {},
            objectAttributesJoins: {},
            objectAttributeRuleJoins: {},
            objectAttributesJoinsReverseLookup: {},
            objectAttributesNewestValues: {},
            objectAttributesHistoryValues: {},
            accountNotifcations: {},
            doghouseHistory: {},
            doghouseActive: {},
            notificationRules: {},
            notificationRuleJoins: {},
            watchdogDbConnected: false,
            usersContactEmails: {},
            transcations_state: {},
            orgCountAndLoading: {},
            componentLoadingStates: {},
            RxTxLogData: {},
            itemsCountForCsvReport: {},
            deletedObjectUids: {},
            orgNotificationGroupJoins: {},
            notificationGroupMetaData: {},
            notificationGroupAlertData: {},
            doghouseActiveCountOrgLevel: {},
            doghouseActiveCountSysLevel: {},
            doghouseActiveCountObjectLevel: {},
            doghouseActiveCountObjAtrLevel: {},
            doghouseAcknowledgedCountOrgLevel: {},
            doghouseAcknowledgedCountSysLevel: {},
            doghouseAcknowledgedCountObjectLevel: {},
            doghouseAcknowledgedCountObjAtrLevel: {},
            doghouseUpdateCountRequestStatus: {}
        },
        backForwardUrlRequest: {
          count: 0
        },
        selectedSubModals: []
    },
    router,
    store
})


//////// start reference assignments from website backend classes to vue
window.G_watchdog_data.IV_org_meta_data = window.vue_instance.$data.watchdog.orgMetaData
window.G_watchdog_data.IV_system_org_joins = window.vue_instance.$data.watchdog.orgSystemJoinsReverseLookup
window.G_watchdog_data.IV_systems_meta_data = window.vue_instance.$data.watchdog.systemsMetaData
window.G_watchdog_data.IV_objects_meta_data = window.vue_instance.$data.watchdog.objectsMetaData
window.G_watchdog_data.IV_object_attributes_meta_data = window.vue_instance.$data.watchdog.objectAttributesMetaData
window.G_watchdog_data.IV_presets = window.vue_instance.$data.watchdog.presets
window.G_watchdog_data.IV_org_permissions = window.vue_instance.$data.watchdog.orgPermissions
window.G_watchdog_data.IV_system_object_joins = window.vue_instance.$data.watchdog.systemObjectJoins
window.G_watchdog_data.IV_system_object_joins_reverse_lookup = window.vue_instance.$data.watchdog.systemObjectJoinsReverseLookup
window.G_watchdog_data.IV_object_attribute_joins = window.vue_instance.$data.watchdog.objectAttributesJoins
window.G_watchdog_data.IV_object_attribute_values = window.vue_instance.$data.watchdog.objectAttributesNewestValues
window.G_watchdog_data.IV_doghouse_history = window.vue_instance.$data.watchdog.doghouseHistory
window.G_watchdog_data.IV_doghouse_active = window.vue_instance.$data.watchdog.doghouseActive
window.G_watchdog_data.IV_notification_rules = window.vue_instance.$data.watchdog.notificationRules
window.G_watchdog_data.IV_notification_rule_joins = window.vue_instance.$data.watchdog.notificationRuleJoins
window.G_watchdog_data.IV_org_parent_lists = window.vue_instance.$data.watchdog.orgParentsLookup
window.G_watchdog_data.IV_object_attribute_joins_reverse_lookup = window.vue_instance.$data.watchdog.objectAttributesJoinsReverseLookup
window.G_watchdog_data.IV_account_notificaitons = window.vue_instance.$data.watchdog.accountNotifcations
window.G_watchdog_data.IV_org_users_permissions_last_updated  = window.vue_instance.$data.watchdog.orgUserPermissionsLastUpdated
window.G_watchdog_data.IV_object_attribute_rule_joins = window.vue_instance.$data.watchdog.objectAttributeRuleJoins
window.G_watchdog_data.IV_users_contact_email = window.vue_instance.$data.watchdog.usersContactEmails
window.G_watchdog_data.IV_vue_transcations = window.vue_instance.$data.watchdog.transcations_state
window.G_watchdog_data.IV_org_count_and_loading = window.vue_instance.$data.watchdog.orgCountAndLoading
window.G_watchdog_data.IV_component_loading_states = window.vue_instance.$data.watchdog.componentLoadingStates
window.G_watchdog_data.IV_rx_tx_log_data = window.vue_instance.$data.watchdog.RxTxLogData
window.G_watchdog_data.IV_items_count_for_csv_report = window.vue_instance.$data.watchdog.itemsCountForCsvReport
window.G_watchdog_data.IV_deleted_object_uids = window.vue_instance.$data.watchdog.deletedObjectUids
window.G_watchdog_data.IV_org_ngp_joins = window.vue_instance.$data.watchdog.orgNotificationGroupJoins
window.G_watchdog_data.IV_ngp_meta_data = window.vue_instance.$data.watchdog.notificationGroupMetaData
window.G_watchdog_data.IV_ngp_triggered_alerts_entries = window.vue_instance.$data.watchdog.notificationGroupAlertData
window.G_watchdog_data.IV_doghouse_active_count_org_level = window.vue_instance.$data.watchdog.doghouseActiveCountOrgLevel
window.G_watchdog_data.IV_doghouse_active_count_sys_level = window.vue_instance.$data.watchdog.doghouseActiveCountSysLevel
window.G_watchdog_data.IV_doghouse_active_count_object_level = window.vue_instance.$data.watchdog.doghouseActiveCountObjectLevel
window.G_watchdog_data.IV_doghouse_active_count_obj_atr_level = window.vue_instance.$data.watchdog.doghouseActiveCountObjAtrLevel
window.G_watchdog_data.IV_doghouse_acknowledged_count_org_level = window.vue_instance.$data.watchdog.doghouseAcknowledgedCountOrgLevel
window.G_watchdog_data.IV_doghouse_acknowledged_count_sys_level = window.vue_instance.$data.watchdog.doghouseAcknowledgedCountSysLevel
window.G_watchdog_data.IV_doghouse_acknowledged_count_object_level = window.vue_instance.$data.watchdog.doghouseAcknowledgedCountObjectLevel
window.G_watchdog_data.IV_doghouse_acknowledged_count_obj_atr_level = window.vue_instance.$data.watchdog.doghouseAcknowledgedCountObjAtrLevel
window.G_watchdog_data.IV_doghouse_update_count_request_status = window.vue_instance.$data.watchdog.doghouseUpdateCountRequestStatus
//////// </end> reference assignments from website backend classes to vue


window.G_firebase_auth.bi5InitFirebase()



// WEBPACK FOOTER //
// ./src/main.js